// import React, { useState } from "react";
// import "./style/bookingDate.css";
// import { assets } from "../../../assets/assets";

// function BookingDate({ lang, isOpen, toggleOpen }) {
//   const today = new Date();
//   today.setHours(0, 0, 0, 0);

//   const [currentMonth, setCurrentMonth] = useState(today.getMonth());
//   const [currentYear, setCurrentYear] = useState(today.getFullYear());

//   const [startDate] = useState(today);
//   const [endDate, setEndDate] = useState(null);
//   // الحالة الخاصة بالماوس لمعاينة التحديد قبل الضغط
//   const [hoverDate, setHoverDate] = useState(null);

//   const monthNames =
//     lang === "ar"
//       ? [
//           "يناير",
//           "فبراير",
//           "مارس",
//           "أبريل",
//           "مايو",
//           "يونيو",
//           "يوليو",
//           "أغسطس",
//           "سبتمبر",
//           "أكتوبر",
//           "نوفمبر",
//           "ديسمبر",
//         ]
//       : [
//           "January",
//           "February",
//           "March",
//           "April",
//           "May",
//           "June",
//           "July",
//           "August",
//           "September",
//           "October",
//           "November",
//           "December",
//         ];

//   const weekDays =
//     lang === "ar"
//       ? ["إث", "ث", "أر", "خ", "جم", "سب", "أح"]
//       : ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];

//   const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
//   const firstDay = new Date(currentYear, currentMonth, 1).getDay();
//   const adjustedFirstDay = firstDay === 0 ? 6 : firstDay - 1;

//   const handleDayClick = (day) => {
//     const clickedDate = new Date(currentYear, currentMonth, day);
//     clickedDate.setHours(0, 0, 0, 0);

//     if (clickedDate < today) return;

//     if (clickedDate.getTime() === today.getTime()) {
//       if (endDate && endDate.getTime() === today.getTime()) {
//         setEndDate(null);
//       } else {
//         setEndDate(new Date(today));
//       }
//       return;
//     }

//     const isSelected =
//       endDate && clickedDate >= today && clickedDate <= endDate;

//     if (isSelected) {
//       const newEnd = new Date(clickedDate);
//       newEnd.setDate(newEnd.getDate() - 1);
//       if (newEnd.getTime() === today.getTime()) {
//         setEndDate(null);
//       } else {
//         setEndDate(newEnd);
//       }
//     } else {
//       setEndDate(clickedDate);
//     }
//   };

//   // دوال الـ Hover
//   const handleMouseEnter = (day) => {
//     const date = new Date(currentYear, currentMonth, day);
//     date.setHours(0, 0, 0, 0);
//     if (date >= today) {
//       setHoverDate(date);
//     }
//   };

//   const handleMouseLeave = () => {
//     setHoverDate(null);
//   };

//   const formatDate = (date) => {
//     if (!date) return "";
//     return `${date.getDate()} ${monthNames[date.getMonth()]} ${date.getFullYear()}`;
//   };

//   return (
//     <div className="booking-date-container col-12">
//       <p className="property-type">Booking Date</p>

//       <div className="dropdown col-12">
//         <button
//           className="btn btn-type dropdown-toggle col-12"
//           type="button"
//           onClick={toggleOpen}
//         >
//           <span className="date-text-display">
//             {/* {formatDate(startDate)} {endDate ? ` - ${formatDate(endDate)}` : ""} */}
//              {formatDate(startDate)}  - {endDate ? ` ${formatDate(endDate)}` : ""}
//           </span>
//           <img
//             src={assets.arrowDropdownWhite}
//             alt="icon"
//             className={`filter-icon arrow-icon ${isOpen ? "open" : ""}`}
//           />
//         </button>

//         {isOpen && (
//           <div
//             className="dropdown-menu show col-12 p-0"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="calendar-form">
//               <div className="calendar-header">
//                 <p className="month-year-text">
//                   {monthNames[currentMonth]} {currentYear}
//                 </p>
//                 <div className="nav-arrows">
//                   <button
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setCurrentMonth((m) => (m === 0 ? 11 : m - 1));
//                       if (currentMonth === 0) setCurrentYear((y) => y - 1);
//                     }}
//                     className="arrow-btn"
//                   >
//                     ‹
//                   </button>
//                   <button
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setCurrentMonth((m) => (m === 11 ? 0 : m + 1));
//                       if (currentMonth === 11) setCurrentYear((y) => y + 1);
//                     }}
//                     className="arrow-btn"
//                   >
//                     ›
//                   </button>
//                 </div>
//               </div>

//               <div className="calendar-grid">
//                 {weekDays.map((d) => (
//                   <div key={d} className="calendar-day header-day">
//                     {d}
//                   </div>
//                 ))}
//                 {Array.from({ length: adjustedFirstDay }).map((_, i) => (
//                   <div key={`empty-${i}`} className="calendar-day empty" />
//                 ))}

//                 {Array.from({ length: daysInMonth }).map((_, i) => {
//                   const day = i + 1;
//                   const cellDate = new Date(currentYear, currentMonth, day);
//                   cellDate.setHours(0, 0, 0, 0);

//                   const isPast = cellDate < today;

//                   // التحديد الفعلي بالضغط
//                   const isSelected =
//                     (startDate && cellDate.getTime() === startDate.getTime()) ||
//                     (endDate && cellDate >= startDate && cellDate <= endDate);

//                   // التحديد المؤقت بالماوس (Preview)
//                   // يلون من "النهاردة" لحد مكان الماوس بشرط ميكونش التاريخ قديم
//                   const isHoveredPreview =
//                     hoverDate && cellDate > today && cellDate <= hoverDate;

//                   return (
//                     <div
//                       key={day}
//                       className={`calendar-day 
//                         ${isSelected || isHoveredPreview ? "selected" : ""} 
//                         ${isPast ? "disabled-day" : ""}`}
//                       onClick={() => handleDayClick(day)}
//                       onMouseEnter={() => handleMouseEnter(day)}
//                       onMouseLeave={handleMouseLeave}
//                     >
//                       {day}
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default BookingDate;
// import React, { useState, useEffect } from "react"; // أضفنا useEffect فقط للربط
// import "./style/bookingDate.css";
// import { assets } from "../../../assets/assets";
// import { useTabsFilter } from "../../../context/TabsFilterContext"; // استيراد الـ context

// function BookingDate({ lang, isOpen, toggleOpen }) {
//   // --- ربط الكونتكت ---
//   const { onFilterChange } = useTabsFilter();

//   const today = new Date();
//   today.setHours(0, 0, 0, 0);

//   const [currentMonth, setCurrentMonth] = useState(today.getMonth());
//   const [currentYear, setCurrentYear] = useState(today.getFullYear());

//   const [startDate] = useState(today);
//   const [endDate, setEndDate] = useState(null);
//   const [hoverDate, setHoverDate] = useState(null);

//   // --- 🔥 الربط مع الباك إند بدون تغيير المنطق الداخلي ---
//   useEffect(() => {
//     // نرسل التاريخ المختار (سواء اليوم فقط أو المدى المختار) بصيغة ISO للباك إند
//     const finalDate = endDate ? endDate : startDate;
//     onFilterChange("bookingDate", finalDate.toISOString());
//   }, [endDate, startDate, onFilterChange]);

//   const monthNames =
//     lang === "ar"
//       ? ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"]
//       : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

//   const weekDays =
//     lang === "ar"
//       ? ["إث", "ث", "أر", "خ", "جم", "سب", "أح"]
//       : ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];

//   const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
//   const firstDay = new Date(currentYear, currentMonth, 1).getDay();
//   const adjustedFirstDay = firstDay === 0 ? 6 : firstDay - 1;

//   // --- نفس المنطق الخاص بكِ تماماً بدون أي تعديل ---
//   const handleDayClick = (day) => {
//     const clickedDate = new Date(currentYear, currentMonth, day);
//     clickedDate.setHours(0, 0, 0, 0);

//     if (clickedDate < today) return;

//     if (clickedDate.getTime() === today.getTime()) {
//       if (endDate && endDate.getTime() === today.getTime()) {
//         setEndDate(null);
//       } else {
//         setEndDate(new Date(today));
//       }
//       return;
//     }

//     const isSelected = endDate && clickedDate >= today && clickedDate <= endDate;

//     if (isSelected) {
//       const newEnd = new Date(clickedDate);
//       newEnd.setDate(newEnd.getDate() - 1);
//       if (newEnd.getTime() === today.getTime()) {
//         setEndDate(null);
//       } else {
//         setEndDate(newEnd);
//       }
//     } else {
//       setEndDate(clickedDate);
//     }
//   };

//   const handleMouseEnter = (day) => {
//     const date = new Date(currentYear, currentMonth, day);
//     date.setHours(0, 0, 0, 0);
//     if (date >= today) {
//       setHoverDate(date);
//     }
//   };

//   const handleMouseLeave = () => {
//     setHoverDate(null);
//   };

//   const formatDate = (date) => {
//     if (!date) return "";
//     return `${date.getDate()} ${monthNames[date.getMonth()]} ${date.getFullYear()}`;
//   };

//   return (
//     <div className="booking-date-container col-12">
//       <p className="property-type">Booking Date</p>

//       <div className="dropdown col-12">
//         <button
//           className="btn btn-type dropdown-toggle col-12"
//           type="button"
//           onClick={toggleOpen}
//         >
//           <span className="date-text-display">
//             {formatDate(startDate)} - {endDate ? ` ${formatDate(endDate)}` : ""}
//           </span>
//           <img
//             src={assets.arrowDropdownWhite}
//             alt="icon"
//             className={`filter-icon arrow-icon ${isOpen ? "open" : ""}`}
//           />
//         </button>

//         {isOpen && (
//           <div
//             className="dropdown-menu show col-12 p-0"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="calendar-form">
//               <div className="calendar-header">
//                 <p className="month-year-text">
//                   {monthNames[currentMonth]} {currentYear}
//                 </p>
//                 <div className="nav-arrows">
//                   <button
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setCurrentMonth((m) => (m === 0 ? 11 : m - 1));
//                       if (currentMonth === 0) setCurrentYear((y) => y - 1);
//                     }}
//                     className="arrow-btn"
//                   >
//                     ‹
//                   </button>
//                   <button
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setCurrentMonth((m) => (m === 11 ? 0 : m + 1));
//                       if (currentMonth === 11) setCurrentYear((y) => y + 1);
//                     }}
//                     className="arrow-btn"
//                   >
//                     ›
//                   </button>
//                 </div>
//               </div>

//               <div className="calendar-grid">
//                 {weekDays.map((d) => (
//                   <div key={d} className="calendar-day header-day">
//                     {d}
//                   </div>
//                 ))}
//                 {Array.from({ length: adjustedFirstDay }).map((_, i) => (
//                   <div key={`empty-${i}`} className="calendar-day empty" />
//                 ))}

//                 {Array.from({ length: daysInMonth }).map((_, i) => {
//                   const day = i + 1;
//                   const cellDate = new Date(currentYear, currentMonth, day);
//                   cellDate.setHours(0, 0, 0, 0);

//                   const isPast = cellDate < today;

//                   const isSelected =
//                     (startDate && cellDate.getTime() === startDate.getTime()) ||
//                     (endDate && cellDate >= startDate && cellDate <= endDate);

//                   const isHoveredPreview =
//                     hoverDate && cellDate > today && cellDate <= hoverDate;

//                   return (
//                     <div
//                       key={day}
//                       className={`calendar-day 
//                         ${isSelected || isHoveredPreview ? "selected" : ""} 
//                         ${isPast ? "disabled-day" : ""}`}
//                       onClick={() => handleDayClick(day)}
//                       onMouseEnter={() => handleMouseEnter(day)}
//                       onMouseLeave={handleMouseLeave}
//                     >
//                       {day}
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default BookingDate;
import React, { useState, useEffect, useRef, useMemo } from "react"; 
import "./style/bookingDate.css";
import { assets } from "../../../assets/assets";
import { useTabsFilter } from "../../../context/TabsFilterContext"; 
import { useFilterContext } from "../../../context/FilterContext"; 

function BookingDate({ lang, isOpen, toggleOpen }) {
  const { onFilterChange } = useTabsFilter();
  const { units } = useFilterContext();

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const [currentMonth, setCurrentMonth] = useState(today.getMonth());
  const [currentYear, setCurrentYear] = useState(today.getFullYear());
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [hoverDate, setHoverDate] = useState(null);
  const [isYearPickerOpen, setIsYearPickerOpen] = useState(false);
  
  // 🔥 إدارة مدى السنوات ديناميكياً
  const [yearRange, setYearRange] = useState({
    max: today.getFullYear() + 20, // يبدأ بـ 20 سنة في المستقبل
    min: today.getFullYear() - 50  // و 50 سنة في الماضي
  });

  const lastSentValueRef = useRef("");
  const yearListRef = useRef(null);

  // توليد مصفوفة السنوات بناءً على المدى الديناميكي
  const years = useMemo(() => {
    const yearsArray = [];
    for (let i = yearRange.max; i >= yearRange.min; i--) {
      if (i > 0) yearsArray.push(i); // حماية من الوصول لسنة 0
    }
    return yearsArray;
  }, [yearRange]);

  // دالة مراقبة التمرير (Scroll) لزيادة السنوات باستمرار
  const handleYearScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    
    // إذا اقترب من القاع (زيادة سنوات الماضي)
    if (scrollHeight - scrollTop <= clientHeight + 100) {
      setYearRange(prev => ({ ...prev, min: prev.min - 50 }));
    }
    
    // إذا اقترب من القمة (زيادة سنوات المستقبل)
    if (scrollTop <= 50) {
      setYearRange(prev => ({ ...prev, max: prev.max + 50 }));
    }
  };

  useEffect(() => {
    if (isYearPickerOpen && yearListRef.current) {
      const activeItem = yearListRef.current.querySelector(".year-accordion-item.active");
      if (activeItem) {
        yearListRef.current.scrollTop = activeItem.offsetTop - 100;
      }
    }
  }, [isYearPickerOpen]);

  const bookedDatesTime = useMemo(() => {
    return new Set(
      units.filter(u => u.booking_date).map(u => {
          const d = new Date(u.booking_date);
          d.setHours(0, 0, 0, 0);
          return d.getTime();
      })
    );
  }, [units]);

  const handleClear = (e) => {
    e.stopPropagation();
    setStartDate(null);
    setEndDate(null);
    onFilterChange("bookingDate", ""); 
    lastSentValueRef.current = "";
  };

  useEffect(() => {
    let finalValue = "";
    if (startDate) {
      const startStr = startDate.toISOString();
      const endStr = endDate ? endDate.toISOString() : startStr;
      finalValue = `${startStr},${endStr}`;
    }
    if (lastSentValueRef.current === finalValue) return;
    onFilterChange("bookingDate", finalValue);
    lastSentValueRef.current = finalValue;
  }, [endDate, startDate, onFilterChange]);

  const monthNames = lang === "ar"
      ? ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"]
      : ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const fullMonthNames = lang === "ar"
      ? ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"]
      : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const weekDays = lang === "ar"
      ? ["إث", "ث", "أر", "خ", "جم", "سب", "أح"]
      : ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];

  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  const firstDay = new Date(currentYear, currentMonth, 1).getDay();
  const adjustedFirstDay = firstDay === 0 ? 6 : firstDay - 1;

  const handleDayClick = (day) => {
    const clickedDate = new Date(currentYear, currentMonth, day);
    clickedDate.setHours(0, 0, 0, 0);
    if (!startDate) { setStartDate(clickedDate); return; }
    if (clickedDate.getTime() === startDate.getTime()) {
      if (endDate && endDate.getTime() === startDate.getTime()) { setEndDate(null); } 
      else { setEndDate(new Date(clickedDate)); }
      return;
    }
    if (endDate && clickedDate >= startDate && clickedDate <= endDate) {
      const newEnd = new Date(clickedDate);
      newEnd.setDate(newEnd.getDate() - 1);
      setEndDate(newEnd < startDate ? null : newEnd);
    } else {
      if (clickedDate < startDate) { setStartDate(clickedDate); setEndDate(null); } 
      else { setEndDate(clickedDate); }
    }
  };

  const changeMonth = (direction) => {
    if (direction === "prev") {
      if (currentMonth === 0) {
          setCurrentMonth(11);
          setCurrentYear(prev => prev - 1);
      } else {
        setCurrentMonth(prev => prev - 1);
      }
    } else {
      if (currentMonth === 11) {
          setCurrentMonth(0);
          setCurrentYear(prev => prev + 1);
      } else {
        setCurrentMonth(prev => prev + 1);
      }
    }
  };

  return (
    <div className="booking-date-container col-12">
      <div className="d-flex justify-content-between align-items-center mb-1">
        <p className="property-type m-0">{lang === "ar" ? "تاريخ الحجز" : "Booking Date"}</p>
        <button onClick={handleClear} className="clear-btn">
          {lang === "ar" ? "عرض الكل" : "show all"}
        </button>
      </div>

      <div className="dropdown col-12">
        <button className="btn btn-type dropdown-toggle col-12" type="button" onClick={toggleOpen}>
          <span className="date-text-display">
            {startDate ? `${startDate.getDate()} ${fullMonthNames[startDate.getMonth()]} ${startDate.getFullYear()}${endDate ? " - " + endDate.getDate() + " " + fullMonthNames[endDate.getMonth()] + " " + endDate.getFullYear() : ""}` : (lang === "ar" ? "كل الفلل المحجوزة" : "All Booked Villas")}
          </span>
          <img src={assets.arrowDropdownWhite} alt="icon" className={`filter-icon arrow-icon ${isOpen ? "open" : ""}`} />
        </button>

        {isOpen && (
          <div className="dropdown-menu show col-12 p-0" onClick={(e) => e.stopPropagation()}>
            <div className="calendar-form">
              <div className="calendar-header d-flex justify-content-between align-items-center px-2 py-1">
                <div className="month-year-clickable" onClick={() => setIsYearPickerOpen(!isYearPickerOpen)}>
                  {fullMonthNames[currentMonth]} {currentYear} <span className="small-arrow">▾</span>
                </div>
                {!isYearPickerOpen && (
                  <div className="nav-arrows">
                    <button onClick={() => changeMonth("prev")} className="arrow-btn">‹</button>
                    <button onClick={() => changeMonth("next")} className="arrow-btn">›</button>
                  </div>
                )}
              </div>

              {isYearPickerOpen ? (
                <div 
                    className="year-accordion-list" 
                    ref={yearListRef}
                    onScroll={handleYearScroll} /* تفعيل زيادة السنين عند السكرول */
                >
                  {years.map(y => (
                    <div key={y} className={`year-accordion-item ${y === currentYear ? "active" : ""}`}>
                      <div className="year-label" onClick={() => setCurrentYear(y)}>
                        {y}
                      </div>
                      {y === currentYear && (
                        <div className="month-selector-grid-inline">
                          {monthNames.map((m, index) => (
                            <div 
                              key={m} 
                              className={`month-cell-inline ${index === currentMonth ? "selected" : ""}`}
                              onClick={() => {
                                setCurrentMonth(index);
                                setIsYearPickerOpen(false);
                              }}
                            >
                              {m}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="calendar-grid">
                  {weekDays.map((d) => <div key={d} className="calendar-day header-day">{d}</div>)}
                  {Array.from({ length: adjustedFirstDay }).map((_, i) => <div key={`empty-${i}`} className="calendar-day empty" />)}
                  {Array.from({ length: daysInMonth }).map((_, i) => {
                    const day = i + 1;
                    const cellDate = new Date(currentYear, currentMonth, day);
                    cellDate.setHours(0, 0, 0, 0);
                    const cellTime = cellDate.getTime();
                    const hasBooking = bookedDatesTime.has(cellTime);
                    const isSelected = startDate && (cellTime === startDate.getTime() || (endDate && cellTime >= startDate.getTime() && cellTime <= endDate.getTime()));
                    const isHovered = startDate && !endDate && hoverDate && cellTime > startDate.getTime() && cellTime <= hoverDate.getTime();
                    return (
                      <div
                        key={day}
                        className={`calendar-day ${isSelected || isHovered ? "selected" : ""} ${hasBooking ? "day-has-data" : ""}`}
                        onClick={() => handleDayClick(day)}
                        onMouseEnter={() => startDate && !endDate && setHoverDate(cellDate)}
                        onMouseLeave={() => setHoverDate(null)}
                      >
                        {day}
                        {hasBooking && <span className="data-dot"></span>}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default BookingDate;
// import React, { useState, useEffect } from "react"; 
// import "./style/bookingDate.css";
// import { assets } from "../../../assets/assets";
// import { useTabsFilter } from "../../../context/TabsFilterContext"; 

// function BookingDate({ lang, isOpen, toggleOpen }) {
//   const { onFilterChange } = useTabsFilter();

//   const today = new Date();
//   today.setHours(0, 0, 0, 0);

//   const [currentMonth, setCurrentMonth] = useState(today.getMonth());
//   const [currentYear, setCurrentYear] = useState(today.getFullYear());

//   // جعلنا الـ startDate مرن وليس ثابتاً على اليوم فقط للسماح باختيار تواريخ قديمة
//   const [startDate, setStartDate] = useState(today);
//   const [endDate, setEndDate] = useState(null);
//   const [hoverDate, setHoverDate] = useState(null);

//   useEffect(() => {
//     const finalDate = endDate ? endDate : startDate;
//     onFilterChange("bookingDate", finalDate.toISOString());
//   }, [endDate, startDate, onFilterChange]);

//   const monthNames =
//     lang === "ar"
//       ? ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"]
//       : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

//   const weekDays =
//     lang === "ar"
//       ? ["إث", "ث", "أر", "خ", "جم", "سب", "أح"]
//       : ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];

//   const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
//   const firstDay = new Date(currentYear, currentMonth, 1).getDay();
//   const adjustedFirstDay = firstDay === 0 ? 6 : firstDay - 1;

//   // const handleDayClick = (day) => {
//   //   const clickedDate = new Date(currentYear, currentMonth, day);
//   //   clickedDate.setHours(0, 0, 0, 0);

//   //   // تم حذف شرط (clickedDate < today) للسماح بالتواريخ القديمة

//   //   if (clickedDate.getTime() === startDate.getTime()) {
//   //       if (endDate && endDate.getTime() === startDate.getTime()) {
//   //           setEndDate(null);
//   //       } else {
//   //           setEndDate(new Date(clickedDate));
//   //       }
//   //       return;
//   //   }

//   //   const isSelected = endDate && clickedDate >= startDate && clickedDate <= endDate;

//   //   if (isSelected) {
//   //     const newEnd = new Date(clickedDate);
//   //     newEnd.setDate(newEnd.getDate() - 1);
//   //     if (newEnd < startDate) {
//   //       setEndDate(null);
//   //     } else {
//   //       setEndDate(newEnd);
//   //     }
//   //   } else {
//   //       if (clickedDate < startDate) {
//   //           // إذا اختار تاريخ قبل تاريخ البداية، نجعله هو البداية الجديدة
//   //           setStartDate(clickedDate);
//   //           setEndDate(null);
//   //       } else {
//   //           setEndDate(clickedDate);
//   //       }
//   //   }
//   // };
// const handleDayClick = (day) => {
//     const clickedDate = new Date(currentYear, currentMonth, day);
//     clickedDate.setHours(0, 0, 0, 0);

//     // 🔥 كونسول لمراقبة اليوم الذي تم النقر عليه
//     console.log("🖱️ Day Clicked:", clickedDate.toDateString());

//     if (clickedDate.getTime() === startDate.getTime()) {
//         if (endDate && endDate.getTime() === startDate.getTime()) {
//             console.log("🔄 Resetting EndDate (Clicked same as start)");
//             setEndDate(null);
//         } else {
//             console.log("📍 Setting EndDate (Same as start)");
//             setEndDate(new Date(clickedDate));
//         }
//         return;
//     }

//     const isSelected = endDate && clickedDate >= startDate && clickedDate <= endDate;

//     if (isSelected) {
//       console.log("➖ Shrinking range...");
//       const newEnd = new Date(clickedDate);
//       newEnd.setDate(newEnd.getDate() - 1);
//       if (newEnd < startDate) {
//         setEndDate(null);
//       } else {
//         setEndDate(newEnd);
//       }
//     } else {
//         if (clickedDate < startDate) {
//             console.log("⬅️ Selected date is before StartDate, shifting StartDate");
//             setStartDate(clickedDate);
//             setEndDate(null);
//         } else {
//             console.log("➡️ Setting new EndDate");
//             setEndDate(clickedDate);
//         }
//     }
//   };
//   const handleMouseEnter = (day) => {
//     const date = new Date(currentYear, currentMonth, day);
//     date.setHours(0, 0, 0, 0);
//     // تم إزالة شرط المقارنة بـ today هنا أيضاً
//     setHoverDate(date);
//   };

//   const handleMouseLeave = () => {
//     setHoverDate(null);
//   };

//   const formatDate = (date) => {
//     if (!date) return "";
//     return `${date.getDate()} ${monthNames[date.getMonth()]} ${date.getFullYear()}`;
//   };
// useEffect(() => {
//     const finalDate = endDate ? endDate : startDate;
    
//     // 🔥 كونسول لمراقبة ما يُرسل للـ Context
//     console.log("🚀 Sending to Context:", {
//       type: "bookingDate",
//       value: finalDate.toISOString(),
//       readable: formatDate(finalDate)
//     });

//     onFilterChange("bookingDate", finalDate.toISOString());
//   }, [endDate, startDate, onFilterChange]);
//   return (
//     <div className="booking-date-container col-12">
//       <p className="property-type">Booking Date</p>

//       <div className="dropdown col-12">
//         <button
//           className="btn btn-type dropdown-toggle col-12"
//           type="button"
//           onClick={toggleOpen}
//         >
//           <span className="date-text-display">
//             {formatDate(startDate)} - {endDate ? ` ${formatDate(endDate)}` : ""}
//           </span>
//           <img
//             src={assets.arrowDropdownWhite}
//             alt="icon"
//             className={`filter-icon arrow-icon ${isOpen ? "open" : ""}`}
//           />
//         </button>

//         {isOpen && (
//           <div
//             className="dropdown-menu show col-12 p-0"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="calendar-form">
//               <div className="calendar-header">
//                 <p className="month-year-text">
//                   {monthNames[currentMonth]} {currentYear}
//                 </p>
//                 <div className="nav-arrows">
//                   <button
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setCurrentMonth((m) => (m === 0 ? 11 : m - 1));
//                       if (currentMonth === 0) setCurrentYear((y) => y - 1);
//                     }}
//                     className="arrow-btn"
//                   >
//                     ‹
//                   </button>
//                   <button
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setCurrentMonth((m) => (m === 11 ? 0 : m + 1));
//                       if (currentMonth === 11) setCurrentYear((y) => y + 1);
//                     }}
//                     className="arrow-btn"
//                   >
//                     ›
//                   </button>
//                 </div>
//               </div>

//               <div className="calendar-grid">
//                 {weekDays.map((d) => (
//                   <div key={d} className="calendar-day header-day">
//                     {d}
//                   </div>
//                 ))}
//                 {Array.from({ length: adjustedFirstDay }).map((_, i) => (
//                   <div key={`empty-${i}`} className="calendar-day empty" />
//                 ))}

//                 {Array.from({ length: daysInMonth }).map((_, i) => {
//                   const day = i + 1;
//                   const cellDate = new Date(currentYear, currentMonth, day);
//                   cellDate.setHours(0, 0, 0, 0);

//                   // قمنا بإلغاء خاصية disabled-day للتواريخ القديمة
//                   const isPast = false; 

//                   const isSelected =
//                     (startDate && cellDate.getTime() === startDate.getTime()) ||
//                     (endDate && cellDate >= startDate && cellDate <= endDate);

//                   const isHoveredPreview =
//                     hoverDate && cellDate > startDate && cellDate <= hoverDate;

//                   return (
//                     <div
//                       key={day}
//                       className={`calendar-day 
//                         ${isSelected || isHoveredPreview ? "selected" : ""} 
//                         ${isPast ? "disabled-day" : ""}`}
//                       onClick={() => handleDayClick(day)}
//                       onMouseEnter={() => handleMouseEnter(day)}
//                       onMouseLeave={handleMouseLeave}
//                     >
//                       {day}
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default BookingDate;